var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenPinOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "rgb(107,189,17)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    d: "M17.59 11.922c1.606.516 2.443 1.107 2.443 2.166 0 .373-.066.616-.2.73-.134.115-.402.173-.804.173h-5.425l-.823 8.016h-.536l-.784-8.015H6.038c-.402 0-.67-.064-.804-.193-.134-.13-.2-.365-.2-.71 0-1.058.77-1.65 2.377-2.165.09 0 .18-.03.27-.086.49-.172.802-.444.936-.816L9.82 5.95v-.216c0-.23-.222-.415-.668-.558l-.067-.043h-.067c-.536-.143-.804-.387-.804-.73 0-.402.09-.652.268-.753.18-.1.49-.15.938-.15h6.16c.447 0 .76.05.938.15.178.1.268.35.268.752 0 .344-.268.588-.804.73h-.067l-.067.044c-.446.143-.67.33-.67.558v.215l1.206 5.07c.134.372.446.644.937.816.09.057.18.086.27.086z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPinOff);
export default __webpack_public_path__ + "static/media/green-pin-off.6de43ef10bc17cd12c055bc49730763f.svg";
export { ForwardRef as ReactComponent };